export const FALLBACK_LNG = "nl";
